import React, { useEffect, useState } from "react";
import { Grid, Autocomplete, TextField, Chip, Tooltip } from "@mui/material";
import { doc, getDoc } from "firebase/firestore";
import { firestore } from "firebaseConfig";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiInput from "components/SuiInput";
import CustomButton from "containers/CustomButton";
import ImageUpload from "components/ChooseImage/image";
import RichTextEditor from "components/RichTextEditor";
import MultipleTags from "containers/Tags";
import NutritionModal from "components/NutritionValueModal";
import Createable from "containers/Select";
import { InputOption } from "utils/common";
import { Card } from "@mui/material";
import { toast } from "react-toastify";
import { convertTo24HourFormat } from "utils/common";
import { useDispatch, useSelector } from "react-redux";
import { AddRecipe } from "store/features/recipes";
import { recipeSelector } from "store/features/recipes";

const defaultErrorMessage = {
  name: false,
  description: false,
  preparation: false,
  howToTake: false,
  nutritionValue: false,
  ingredients: false,
  foodType: false,
  calories: false,
  qty: false,
  unit: false,
  foodCategory: false,
  image: false,
};

const defaultformData = {
  name: "",
  description: "",
  preparation: "",
  howToTake: "",
  nutritionValue: "",
  ingredients: "",
  foodType: "",
  groceryList: "",
  calories: "",
  qty: "",
  unit: "",
  foodCategory: "",
  // goesWell: [],
  image: null,
};

const nutritionOptions = [
  "Protein",
  "Fat",
  "Carbohydrate",
  "Sugar",
  "Magnesium",
  "Fibre",
  "Calcium",
  "Iron",
];

const UnitState = [
  { label: "Litre", value: "Litre", key: 0 },
  { label: "Gms", value: "Gms", key: 1 },
  { label: "Ml", value: "Ml", key: 2 },
  { label: "Table Spoon", value: "Table Spoon", key: 3 },
  { label: "Tablet", value: "Tablet", key: 4 },
  { label: "Softgel", value: "Softgel", key: 4 },
  { label: "Katori", value: "Katori", key: 4 },
  { label: "Tea Cup", value: "Tea Cup", key: 4 },
  { label: "Tea Spoon", value: "Tea Spoon", key: 4 },
  { label: "Kernel", value: "Kernel", key: 4 },
  { label: "Bowl", value: "Bowl", key: 4 },
  { label: "Scoop", value: "Scoop", key: 4 },
  { label: "Piece", value: "Piece", key: 4 },
  { label: "Nuts", value: "Nuts", key: 4 },
  { label: "Servings", value: "Servings", key: 4 },
  { label: "Glass", value: "Glass", key: 4 },
  { label: "Small", value: "Small", key: 4 },
  { label: "Big", value: "Big", key: 4 },
  { label: "Medium", value: "Medium", key: 4 },
];

const foodCategory = [
  { label: "Vegetables", value: "Vegetables", key: 1 },
  { label: "Fruits", value: "Fruits", key: 2 },
  { label: "Grains", value: "Grains", key: 3 },
  { label: "Protein Foods", value: "Protein Foods", key: 4 },
  { label: "Dairy", value: "Dairy", key: 5 },
  { label: "Oils & Solid Fats", value: "Oils & Solid Fats", key: 6 },
  { label: "Added Sugars", value: "Added Sugars", key: 7 },
  { label: "Beverages", value: "Beverages", key: 8 },
  { label: "Egg", value: "Egg", key: 9 },
  { label: "Non Veg", value: "Non Veg", key: 10 },
  { label: "Sea Food", value: "Sea Food", key: 11 },
  { label: "Dietary Fiber", value: "Dietary Fiber", key: 12 },
  { label: "Vitamins Rich", value: "Vitamins Rich", key: 13 },
  { label: "Minerals Rich", value: "Minerals Rich", key: 14 },
  { label: "Carbs Rich", value: "Carbs Rich", key: 15 },
  { label: "Protein Rich", value: "Protein Rich", key: 16 },
  { label: "Antioxidants Rich", value: "Antioxidants Rich", key: 17 },
  { label: "Anti-Inflammatory,", value: "Anti-Inflammatory,", key: 18 },
  { label: "Fibers Rich", value: "Fibers Rich", key: 19 },
  { label: "Gut Foods", value: "Gut Foods", key: 20 },
  { label: "Others", value: "Others", key: 21 },
];

const getUnitOption = (unit) => {
  const value = typeof unit === "string" ? unit : unit?.value;
  return UnitState?.find((u) => u.value === value) ?? null;
};

const getUnitValue = (unit) => {
  if (typeof unit === "string") return unit;
  return unit?.value || "";
};

const AddedRecipeEdit = ({
  selectedItem,
  setSelectedItem,
  mode = "edit",
  searchParams,
  setSearchParams,
  dietPlan,
  setDietPlan,
  setMode,
  uid,
}) => {
  const dispatch = useDispatch();

  const { isFetching } = useSelector(recipeSelector);

  const [formData, setformData] = useState(defaultformData);
  const [errorMessage, setErrorMessage] = useState(defaultErrorMessage);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedType, setSelectedType] = useState(null);
  const [message, setMessage] = useState(null);
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [editCalorie, setEditCalorie] = useState(false);
  const [caloriesPerUnit, setCaloriesPerUnit] = useState(null);
  const [constQuantity, setConstQuantity] = useState(null);
  const [constantSelectedItem, setConstantSelectedItem] = useState(null);

  const calculateNutritionValue = (qty) => {
    return selectedOptions
      .map((item, index) => {
        const calc = defaultOptions[index].grams * (qty / constQuantity);
        if (calc > 0) {
          return {
            ...item,
            grams: parseFloat(calc.toFixed(2)),
          };
        } else {
          return null;
        }
      })
      .filter((item) => item !== null);
  };

  const calculateCalories = (qty) => {
    const cal = caloriesPerUnit * qty;
    return parseFloat(cal.toFixed(2));
  };

  const handleRemoveNutrition = (type) => {
    const updatedOptions = selectedOptions.filter((item) => item.type !== type);
    setSelectedOptions(updatedOptions);
    setDefaultOptions(defaultOptions.filter((item) => item.type !== type));
    setformData((prevData) => ({ ...prevData, nutritions: updatedOptions }));
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setMessage(null);
  };

  const handleAddNutrition = ({ grams, unit }) => {
    const existingIndex = selectedOptions.findIndex(
      (item) => item.type === selectedType
    );
    const newItem = { type: selectedType, grams, unit: unit || "g" };

    if (existingIndex !== -1) {
      const updatedOptions = [...selectedOptions];
      updatedOptions[existingIndex] = newItem;
      setSelectedOptions(updatedOptions);
      setformData((prevData) => ({
        ...prevData,
        nutritions: updatedOptions,
      }));
    } else {
      const updated = [...selectedOptions, newItem];
      setSelectedOptions(updated);
      setDefaultOptions([...defaultOptions, newItem]);
      setformData((prevData) => ({
        ...prevData,
        nutritions: updated,
      }));
    }
    setModalOpen(false);
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setformData((prev) => ({ ...prev, image: file }));
    }
  };

  const handleDeleteImage = () => {
    setformData({ ...formData, image: null });
  };

  const handleFoodCategoryChange = (selected) => {
    setformData((prev) => ({
      ...prev,
      foodCategory: selected ?? [],
    }));
  };

  const sanitizeFoodCategory = (data) => {
    if (
      data &&
      typeof data === "object" &&
      Array.isArray(data.label) &&
      Array.isArray(data.value)
    ) {
      return data.label.map((label, idx) => ({
        label,
        value: data.value[idx] ?? label,
      }));
    }
    if (
      data &&
      typeof data === "object" &&
      typeof data.label === "string" &&
      typeof data.value === "string"
    ) {
      return [{ label: data.label, value: data.value }];
    }
    if (Array.isArray(data)) {
      return data
        .map((cat) =>
          typeof cat === "string"
            ? { label: cat, value: cat }
            : typeof cat === "object" && cat?.value
            ? cat
            : null
        )
        .filter(Boolean);
    }
    if (typeof data === "string") {
      return [{ label: data, value: data }];
    }
    return [];
  };

  useEffect(() => {
    let cancelled = false;

    const applyFormData = (source) => {
      if (!source) return;
      const newformData = {
        ...source,
        toggleMode: source.toggleMode || "",
        time: convertTo24HourFormat(source?.time),
        name: source.name
          ? source.name
          : source.name?.label
          ? source.name
          : { label: source.name, value: source.name },
        foodCategory: sanitizeFoodCategory(source.foodCategory),
        unit: source.unit?.label
          ? source.unit
          : { label: source.unit, value: source.unit },
        ingredients: Array.isArray(source.ingredients)
          ? source.ingredients
          : source.ingredients
          ? [source.ingredients]
          : [],
        foodType: Array.isArray(source.foodType)
          ? source.foodType
          : source.foodType
          ? [source.foodType]
          : [],
        groceryList: Array.isArray(source.groceryList)
          ? source.groceryList
          : source.groceryList
          ? [source.groceryList]
          : [],
      };
      setformData(newformData);
      if (!selectedOptions.length && source?.nutritions?.length) {
        setSelectedOptions(source.nutritions);
      }
    };

    const isChartRecipeEdit =
      selectedItem?.scheduleKey && selectedItem?.recipeIndex !== undefined;

    if (isChartRecipeEdit) {
      applyFormData(selectedItem);
    } else if (selectedItem?.id) {
      getDoc(doc(firestore, "recipe", selectedItem.id))
        .then((snap) => {
          if (cancelled) return;
          const latest =
            snap.exists() ? { id: snap.id, ...snap.data() } : selectedItem;
          applyFormData({
            ...latest,
            ...selectedItem,
            id: selectedItem.id,
            time: selectedItem.time,
            toggleMode: selectedItem.toggleMode ?? "OR",
          });
        })
        .catch(() => {
          if (!cancelled) applyFormData(selectedItem);
        });
    } else if (selectedItem) {
      applyFormData(selectedItem);
    }

    if (selectedItem?.id && constantSelectedItem?.id !== selectedItem?.id) {
      setConstantSelectedItem(selectedItem);
      const caloriePerQty =
        parseFloat(selectedItem?.calories) / parseFloat(selectedItem?.qty);
      setCaloriesPerUnit(caloriePerQty);
      setConstQuantity(selectedItem?.qty);
      setEditCalorie(false);
      setDefaultOptions(selectedItem?.nutritions ?? []);
    }

    return () => {
      cancelled = true;
    };
  }, [selectedItem]);

  const onChangeHandler = (e, isToggleClicked) => {
    const name = e?.target.name;
    const value = e?.target.value;
    if (isToggleClicked) {
      const toggleMode = e.target.checked ? "OR" : "AND";
      setformData((ee) => {
        ee["toggleMode"] = toggleMode;
        return ee;
      });
    } else {
      setformData((ee) => ({
        ...ee,
        [name]: value,
      }));
    }

    if (e.target.name === "calories" && selectedItem?.id) {
      setEditCalorie(true);
      setMessage(
        "You have changed the calories, please change qty and nutrition value manually."
      );
    }
    if (e.target.name === "unit" && selectedItem?.id) {
      setEditCalorie(true);
      setMessage(
        "You have changed the unit, please change calories, qty and nutrition value manually."
      );
    }
    if (e.target.name !== "calories" && e.target.name !== "unit") {
      setMessage(null);
    }
    if (
      e.target.name === "qty" &&
      editCalorie === false &&
      selectedItem?.id !== null
    ) {
      const updatedCalories = calculateCalories(e.target.value);
      const updateNutritionValue = calculateNutritionValue(e.target.value);
      setSelectedOptions(updateNutritionValue);
      setformData((prevData) => ({
        ...prevData,
        calories: updatedCalories,
      }));
    }
  };

  const updateDietPlanWithEditedRecipe = () => {
    const sanitizedformData = {
      ...formData,
      foodCategory: formData.foodCategory.map((cat) => cat.value),
      unit: getUnitValue(formData.unit),
      groceryList: Array.isArray(formData.groceryList)
        ? formData.groceryList
        : [],
    };

    if (!dietPlan || !selectedItem?.id) return;

    const updatedPlan = { ...dietPlan };

    if (selectedItem.scheduleKey && Array.isArray(updatedPlan[selectedItem.scheduleKey])) {
      updatedPlan[selectedItem.scheduleKey] = updatedPlan[
        selectedItem.scheduleKey
      ].map((recipe, index) =>
        index === selectedItem.recipeIndex ||
        (selectedItem.instanceId && recipe.instanceId === selectedItem.instanceId)
          ? { ...recipe, ...sanitizedformData }
          : recipe
      );
      setDietPlan(updatedPlan);
      return;
    }

    Object.keys(updatedPlan).forEach((timeSlot) => {
      if (Array.isArray(updatedPlan[timeSlot])) {
        updatedPlan[timeSlot] = updatedPlan[timeSlot].map((recipe) =>
          recipe.id === selectedItem.id
            ? { ...recipe, ...sanitizedformData }
            : recipe
        );
      }
    });

    setDietPlan(updatedPlan);
  };

  const closeModalHandler = () => {
    setMode(null);
    setSelectedItem(null);
    setformData(defaultformData);
    const newParams = new URLSearchParams(searchParams);
    newParams.delete("mode");
    newParams.delete("recipeId");
    setSearchParams(newParams);
  };

  const handleSubmitRecipe = (e) => {

    e.preventDefault();

    if (!formData.name) {
      toast.error("Please enter a Recipe Name");
      setErrorMessage({
        ...errorMessage,
        name: true,
      });
      return;
    }

    if (!formData.foodCategory || formData.foodCategory.length === 0) {
      toast.error("Please fill Food Category field");
      setErrorMessage({
        ...errorMessage,
        foodCategory: true,
      });
      return;
    }

    if (formData.qty === "" || formData.qty === null) {
      toast.error("Please fill quantity field");
      setErrorMessage({
        ...errorMessage,
        qty: true,
      });
      return;
    }

    if (!formData.unit) {
      toast.error("Please fill Unit field");
      setErrorMessage({
        ...errorMessage,
        unit: true,
      });
      return;
    }

    updateDietPlanWithEditedRecipe();

    toast.success("Recipe updated successfully");
    const newParams = new URLSearchParams(searchParams);
    newParams.delete("mode");
    newParams.delete("recipeId");
    setSearchParams(newParams);
    setMode(null);
  };

  const handleSaveRecipe = (e) => {
    e.preventDefault();

    if (!formData.name) {
      toast.error("Please enter a Recipe Name");
      setErrorMessage({
        ...errorMessage,
        name: true,
      });
      return;
    }

    if (!formData.foodCategory || formData.foodCategory.length === 0) {
      toast.error("Please fill Food Category field");
      setErrorMessage({
        ...errorMessage,
        foodCategory: true,
      });
      return;
    }

    if (formData.qty === "" || formData.qty === null) {
      toast.error("Please fill quantity field");
      setErrorMessage({
        ...errorMessage,
        qty: true,
      });
      return;
    }

    if (!formData.unit) {
      toast.error("Please fill Unit field");
      setErrorMessage({
        ...errorMessage,
        unit: true,
      });
      return;
    }

    const sanitizedformData = {
      adminId: uid,
      ...formData,
      foodCategory: formData.foodCategory.map((cat) => cat.value),
      unit: getUnitValue(formData.unit),
    };

    dispatch(AddRecipe({ formdata: sanitizedformData, uid }));
    setMode(null);
  };

  return (
    <Card sx={{ p: 3, mb: 3, borderRadius: "10px" }}>
      <SuiBox
        display="flex"
        justifyContent="space-between"
        alignItems="baseline"
        pt={1}
        pb={0.8}
        px={1}
      >
        <SuiTypography mb={1} variant="h6">
          Edit Added Recipe
        </SuiTypography>

        <SuiBox display="flex" gap={2}>
          <Tooltip
            title="Save this as a new reusable recipe in your recipe list."
            placement="top"
            key={1}
          >
            <CustomButton
              color="dark"
              variant="gradient"
              fullWidth
              onClick={handleSaveRecipe}
              loader={isFetching}
            >
              Save as New Recipe
            </CustomButton>
          </Tooltip>

          <CustomButton
            color="dark"
            variant="gradient"
            fullWidth
            onClick={handleSubmitRecipe}
            // disabled={loader}
            title={"Edit Recipe"}
          />
          <CustomButton
            color="dark"
            variant="gradient"
            fullWidth
            onClick={closeModalHandler}
            // disabled={loader}
            title={"Cancel"}
          />
        </SuiBox>
      </SuiBox>

      <SuiBox
        sx={{ display: "flex", flexDirection: "column", gap: 3 }}
        pt={3}
        pb={0.8}
        px={3}
      >
        {/* First Row */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <SuiBox lineHeight={1}>
              <SuiTypography mb={1} variant="h6">
                Recipe Name*
              </SuiTypography>
              <SuiInput
                fullWidth
                type="text"
                name="name"
                value={formData.name ?? ""}
                onChange={(e) =>
                  setformData((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }))
                }
                required
              />
            </SuiBox>
          </Grid>

          <Grid item xs={12} md={6}>
            <SuiBox lineHeight={1}>
              <SuiTypography mb={1} variant="h6">
                Calories
              </SuiTypography>
              <SuiInput
                type="number"
                placeholder="--/--"
                value={formData.calories ? formData.calories : 0}
                onChange={(e) => {
                  const value = parseFloat(e.target.value);
                  if (value < 0) {
                    return;
                  }
                  setformData((prev) => ({
                    ...prev,
                    calories: value,
                  }));
                  onChangeHandler(e);
                }}
              />
            </SuiBox>
          </Grid>

          <Grid item xs={12} md={4}>
            <SuiBox lineHeight={1}>
              <SuiTypography mb={1} variant="h6">
                Quantity*
              </SuiTypography>
              <SuiInput
                disabled={mode === "view"}
                type="number"
                name="qty"
                readOnly={mode === "view"}
                value={formData.qty ? formData.qty : 0}
                onChange={(e) => {
                  let numberRegex = /^[0-9][0-9]{0,5}?(\.[0-9]{1,2})?$/;
                  let val = e.target.value;
                  let match_ = val.match(numberRegex);
                  if (!match_ && val) {
                    return false;
                  }
                  onChangeHandler(e);
                }}
              />
            </SuiBox>
          </Grid>

          <Grid item xs={12} md={4}>
            <SuiBox lineHeight={1}>
              <SuiTypography mb={1} variant="h6">
                Unit*
              </SuiTypography>
              <Createable
                options={UnitState ?? []}
                disabled={mode === "view"}
                value={getUnitOption(formData.unit)}
                style={{ borderRadius: "0.5rem", fontSize: 14 }}
                inputStyle={{
                  width: 190,
                  height: "1.800rem",
                  borderRadius: "0.5rem",
                }}
                placeholder="Choose unit"
                onChange={(e) => {
                  let eObj = { target: { value: e.value, name: "unit" } };
                  onChangeHandler(eObj);
                }}
              />
            </SuiBox>
          </Grid>

          <Grid item xs={12} md={4}>
            <SuiBox lineHeight={1}>
              <SuiTypography mb={1} variant="h6">
                Food Category*
              </SuiTypography>
              <Createable
                options={foodCategory ?? []}
                disabled={mode === "view"}
                value={formData.foodCategory}
                style={{ borderRadius: "0.5rem", fontSize: 14 }}
                inputStyle={{
                  width: 190,
                  height: "1.800rem",
                  borderRadius: "0.5rem",
                }}
                placeholder="Choose food category"
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{
                  Option: InputOption, // checkbox style
                }}
                onChange={handleFoodCategoryChange}
              />
            </SuiBox>
          </Grid>

          <Grid item xs={12} md={4}>
            <SuiBox lineHeight={1}>
              <SuiTypography mb={1} variant="h6">
                Recipe Description
              </SuiTypography>
              <RichTextEditor
                value={formData.description || ""}
                name="description"
                onChange={(e) =>
                  setformData((prev) => ({
                    ...prev,
                    description: e.target.value,
                  }))
                }
                toolbar={true}
                readOnly={mode === "view"}
                error={errorMessage?.description}
                placeholder="Enter recipe description..."
                borderRadius="10px"
                onlyText={false}
              />
            </SuiBox>
          </Grid>

          <Grid item xs={12} md={4}>
            <SuiBox lineHeight={1}>
              <SuiTypography mb={1} variant="h6">
                How to Take
              </SuiTypography>
              <RichTextEditor
                value={formData.howToTake || ""}
                name="howToTake"
                onChange={(e) =>
                  setformData((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }))
                }
                toolbar={true}
                readOnly={mode === "view"}
                error={errorMessage?.howToTake}
                placeholder="Explain how to take this recipe..."
                borderRadius="10px"
                onlyText={false}
              />
            </SuiBox>
          </Grid>

          <Grid item xs={12} md={4}>
            <SuiBox lineHeight={1}>
              <SuiTypography mb={1} variant="h6">
                How to Prepare
              </SuiTypography>
              <RichTextEditor
                value={formData.preparation || ""}
                name="preparation"
                onChange={(e) =>
                  setformData((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }))
                }
                toolbar={true}
                readOnly={mode === "view"}
                error={errorMessage?.preparation}
                placeholder="Explain how to prepare this recipe..."
                borderRadius="10px"
                onlyText={false}
              />
            </SuiBox>
          </Grid>

          <Grid item xs={12} md={4}>
            <SuiBox lineHeight={1}>
              <SuiTypography mb={1} variant="h6">
                Nutrition Value
              </SuiTypography>
              <Autocomplete
                multiple
                clearIcon={null}
                id="nutrition-input"
                sx={{
                  display: "flex",
                  borderBottom: "none",
                  "& input": {
                    width: 200,
                    bgcolor: "background.paper",
                    borderBottom: "none",
                  },
                }}
                options={nutritionOptions}
                getOptionLabel={(option) => option}
                value={
                  Array.isArray(selectedOptions)
                    ? selectedOptions.map((option) => option.type)
                    : []
                }
                onChange={(event, values) => {
                  const latest = values[values.length - 1];
                  if (!selectedOptions.find((item) => item.type === latest)) {
                    setModalOpen(true);
                    setSelectedType(latest);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Nutrition"
                    autoFocus
                    sx={{
                      "& .MuiAutocomplete-inputRoot": {
                        overflowX: "auto",
                        display: "flex !important",
                        alignItems: "flex-start !important",
                        flexWrap: "wrap !important",
                        height: "80px !important",

                        "&::after": {
                          borderBottom: "none !important",
                        },
                        "&::before": {
                          borderBottom: "none !important",
                        },
                        "&:hover": {
                          // borderBottom: 'none !important',
                          background: "red",
                        },
                      },
                    }}
                    variant="filled"
                  />
                )}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => {
                    const item = selectedOptions.find((x) => x.type === option);
                    return (
                      <Chip
                        key={option}
                        label={
                          item
                            ? `${option}: ${item.grams}${item.unit || "g"}`
                            : option
                        }
                        {...getTagProps({ index })}
                        onDelete={() => {
                          handleRemoveNutrition(option);
                        }}
                      />
                    );
                  })
                }
              />
              <NutritionModal
                open={modalOpen}
                selectedType={selectedType}
                onClose={handleCloseModal}
                onAddNutrition={handleAddNutrition}
              />
            </SuiBox>
          </Grid>

          <Grid item xs={12} md={4}>
            <SuiBox lineHeight={1}>
              <SuiTypography mb={1} variant="h6">
                Ingredients
              </SuiTypography>
              <MultipleTags
                placeholder="Ingredients"
                valList={formData["ingredients"] || []}
                disabled={mode === "view"}
                height="80px !important"
                freeTextHanlder={(val) => {
                  setformData((prev) => ({
                    ...prev,
                    ingredients: val,
                  }));
                }}
              />
            </SuiBox>
          </Grid>

          <Grid item xs={12} md={4}>
            <SuiBox lineHeight={1}>
              <SuiTypography mb={1} variant="h6">
                Food Type
              </SuiTypography>
              <MultipleTags
                placeholder="Food type"
                valList={formData["foodType"] || []}
                disabled={mode === "view"}
                height="80px !important"
                freeTextHanlder={(val) => {
                  setformData((prev) => ({
                    ...prev,
                    foodType: val,
                  }));
                }}
              />
            </SuiBox>
          </Grid>

          <Grid item xs={12} md={4}>
            <SuiBox lineHeight={1}>
              <SuiTypography mb={1} variant="h6">
                Grocery List
              </SuiTypography>
              <MultipleTags
                placeholder="Grocery items"
                valList={formData["groceryList"] || []}
                disabled={mode === "view"}
                height="80px !important"
                freeTextHanlder={(val) => {
                  setformData((prev) => ({
                    ...prev,
                    groceryList: val,
                  }));
                }}
              />
            </SuiBox>
          </Grid>
        </Grid>

        {formData.image ? (
          <ImageUpload
            id="recipe-image-upload"
            variant="dashed"
            image={formData.image}
            onChange={handleFileChange}
            onDelete={handleDeleteImage}
            label="Upload Recipe Image"
            avatarLabel="Upload ⬆"
            previewHeight={120}
            width={250}
          />
        ) : (
          ""
        )}
      </SuiBox>
    </Card>
  );
};

export default AddedRecipeEdit;
